export default __webpack_public_path__ + "static/media/payoutscreen.c4809853.jpg";